import { combineReducers } from "redux";
import crumbsReducer from "./crumbs/crumbs.reducer";
import onboardingReducer from "./onboarding/onboarding.reducer";
import domainAddToCartReducer from "./domainAddToCart/domainAddToCart.reducer";


export default combineReducers({
  crumbs: crumbsReducer,
  onboarding: onboardingReducer,
  domainAddToCart: domainAddToCartReducer,
});